import { createSelector } from 'reselect';
import { ENTERTAINMENT_VIDEO_MAX_DURATION_FALLBACK, ENTERTAINMENT_VIDEO_MAX_FILE_SIZE_FALLBACK } from 'modules/entertainment-videos/constants';
import type { State } from 'types/State.type';

const runtimeConfigSelector = (state: State) => state.runtimeConfig;

export const entertainmentVideoMaxFileSizeSelector = createSelector(
  runtimeConfigSelector,
  ({ config }) => config?.realmEntertainmentVideosMediaMaxFileSizeBytes ?? ENTERTAINMENT_VIDEO_MAX_FILE_SIZE_FALLBACK
);

export const entertainmentVideoMaxDurationSelector = createSelector(
  runtimeConfigSelector,
  ({ config }) => config?.realmEntertainmentVideosMediaMaxDurationSecs ?? ENTERTAINMENT_VIDEO_MAX_DURATION_FALLBACK
);
